module.exports = __webpack_public_path__ + "img/texto_nuestra_gente.e5ef1d69.png";